import { render, staticRenderFns } from "./AtomTextarea.vue?vue&type=template&id=54db9a0b&scoped=true&"
import script from "./AtomTextarea.vue?vue&type=script&lang=js&"
export * from "./AtomTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AtomTextarea.vue?vue&type=style&index=0&id=54db9a0b&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db9a0b",
  null
  
)

export default component.exports